import { TIME_CLASSES } from '../chess/game.js';
import { VARIANTS } from '../chess/variants.js';
import { timeControlClass } from './ratings.js';

export const STANDARD_TIME_CLASSES = TIME_CLASSES;

export const LEADERBOARD_VARIANTS = Object.values(VARIANTS)
  .filter((variant) => variant.id !== 'standard' && variant.leaderboard);

export function certificateVariant(certificate) {
  return certificate?.variant || 'standard';
}

export function ratingBucketForCertificate(certificate) {
  const timeClass = timeControlClass(certificate.timeControl);
  const variant = certificateVariant(certificate);
  if (variant === 'standard') {
    return timeClass;
  }
  return `${variant}:${timeClass}`;
}

export function leaderboardMatchesCertificate(
  certificate,
  { mode = 'standard', timeClass, variant = 'standard' }
) {
  if (!certificate?.rated) {
    return false;
  }

  const certificateTimeClass = timeControlClass(certificate.timeControl);
  if (certificateTimeClass !== timeClass) {
    return false;
  }

  const gameVariant = certificateVariant(certificate);
  if (mode === 'standard') {
    return gameVariant === 'standard';
  }
  return gameVariant === variant;
}

export function leaderboardLabel({ mode, timeClass, variant }) {
  if (mode === 'standard') {
    return timeClass;
  }
  return VARIANTS[variant]?.label || variant;
}
